module.exports = __webpack_public_path__ + "img/zhga-1.f5d7ed04.png";